var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgPartialCircle = function SvgPartialCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.784 2.015c.971-.7 2.364-.628 4.04-.137h.001c2.468.727 4.57 2.83 5.297 5.299.49 1.678.562 3.07-.137 4.043-.71.986-1.984 1.229-3.321 1.229h-3.338c-1.123 0-2.123-.283-2.822-1.06-.684-.758-.948-1.847-.948-3.155V5.338c0-1.338.243-2.613 1.228-3.323Zm.881 1.225c-.342.246-.601.82-.601 2.098v2.896c0 1.147.238 1.788.56 2.146.306.34.813.56 1.702.56h3.338c1.277 0 1.851-.26 2.097-.602.256-.355.388-1.115-.086-2.736-.581-1.976-2.299-3.694-4.274-4.276-1.621-.474-2.38-.342-2.736-.086Z",
    fill: "#123862"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.293 3.508a.754.754 0 0 1-.588.89 8.398 8.398 0 0 0-6.584 9.61c.571 3.491 3.387 6.307 6.875 6.868h.001a8.386 8.386 0 0 0 9.616-6.615.754.754 0 1 1 1.479.297 9.894 9.894 0 0 1-11.336 7.808C5.624 21.7 2.308 18.38 1.632 14.25v-.002A9.907 9.907 0 0 1 9.404 2.92a.754.754 0 0 1 .89.589Z",
    fill: "#123862"
  })));
};
export default SvgPartialCircle;